<template>
    <div
        ref="root"
        class="d-button-dropdown"
    >
        <DButton
            :label="label"
            :disabled="disabled"
            :mini="mini"
            :color="color"
            icon="dots-horizontal"
            @click="toggleDropdown"
        />
        <div
            v-if="isOpen"
            class="d-dropdown"
            @click="toggleDropdown"
        >
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'DButtonDropdown',
    props: {
        label: {
            type: String,
            default: '',
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        mini: {
            type: Boolean,
            required: false,
            default: false
        },
        color: {
            type: String,
            required: false,
            default: 'secondary'
        }
    },
    data () {
        return {
            isOpen: false
        }
    },
    mounted () {
        // Bound on `mousedown` so the dropdown closes before any
        // click handler underneath it fires — feels native.
        document.addEventListener('mousedown', this.handleOutsideClick)
    },
    beforeUnmount () {
        document.removeEventListener('mousedown', this.handleOutsideClick)
    },
    methods: {
        toggleDropdown () {
            this.isOpen = !this.isOpen
        },
        handleOutsideClick (event) {
            if (!this.isOpen) {
                return
            }

            const root = this.$refs.root
            if (root && !root.contains(event.target)) {
                this.isOpen = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.d-button-dropdown {
    position: relative;

    & .d-dropdown {
        width: 250px;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0px 1px 3px rgba(0,0,0,0.24);
        position: absolute;
        z-index: 100;
        right: 0;
        margin-top: 5px;
    }
}
</style>
